export default defineAppConfig({
  showSidebar: true
});
